export default "__VITE_ASSET__DnqHUMG$__"